var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "offload-shipment"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('legend', [_vm._v("Offload Shipment")]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h6', [_vm._v("ShippingID"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" : ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [(((_vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon)).type) === 'checkbox') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "shippingid",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "shippingid",
      "placeholder": "Enter ShippingId",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.shippingid) ? _vm._i(_vm.shippingid, null) > -1 : (_vm.shippingid)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.shippingid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.shippingid = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.shippingid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.shippingid = $$c
        }
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false)) : (((_vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon)).type) === 'radio') ? _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "shippingid",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "shippingid",
      "placeholder": "Enter ShippingId",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.shippingid, null)
    },
    on: {
      "change": function($event) {
        _vm.shippingid = null
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false)) : _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingid),
      expression: "shippingid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "shippingid",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "shippingid",
      "placeholder": "Enter ShippingId",
      "type": (_vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon)).type
    },
    domProps: {
      "value": (_vm.shippingid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingid = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shippingid')),
      expression: "errors.has('shippingid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("ShippingId field is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), (_vm.showTable == true) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "width": "50%",
      "margin-top": "30px",
      "height": "250px"
    }
  }, [_c('table', {
    staticClass: "table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "border-width": "5px",
      "border-style": "#BDC3C7"
    }
  }, [_c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v(" Bag No ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.shipmentDetails.bagno))])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "border-width": "5px",
      "border-style": "#BDC3C7"
    }
  }, [_c('th', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("Offload Reason ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('basic-select', {
    staticClass: "form-control",
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.offloadreasonlist,
      "selected-option": _vm.offloadreasonitem,
      "placeholder": "Select Offload Reason",
      "name": "Offload Reason"
    },
    on: {
      "select": _vm.selectOffloadReason
    },
    model: {
      value: (_vm.offloadreason),
      callback: function($$v) {
        _vm.offloadreason = $$v
      },
      expression: "offloadreason"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.reasonError))])], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "common-secondary",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmoffloadShipment
    }
  }, [_vm._v("Offload Shipment")])])])])]) : _vm._e()])])])], 1), _vm._v(" "), (_vm.ConfirmoffloadShipmentDetails == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Are You Sure"
    },
    model: {
      value: (_vm.ConfirmoffloadShipmentDetails),
      callback: function($$v) {
        _vm.ConfirmoffloadShipmentDetails = $$v
      },
      expression: "ConfirmoffloadShipmentDetails"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure to Mark Shipment Offload..?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabledOK == true
    },
    on: {
      "click": function($event) {
        return _vm.offloadShipment(_vm.shipmentDetails)
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_vm._v("Cancel")])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56f6d314","hasScoped":true}!./src/views/components/OffloadShipment/OffloadShipment.html
// module id = 1246
// module chunks = 2